import { Expo, Linear, TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";
import * as SFX from "../Data/SoundEffect";
import CustomBounce from "../vendor/CustomBounce";
import CultureBackground from "./CultureBackground";

export default class MexicoBackground extends CultureBackground {
    private readonly _flags: PIXI.Sprite[];
    private readonly _objects: PIXI.Sprite[];
    constructor() {
        super();
        this._flags = [
            HLF.PixiUtils.makeSprite("background-00-00", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-00-01", Constants.SPRITESHEET_GAME),
        ];
        this._objects = [
            HLF.PixiUtils.makeSprite("background-00-02", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-00-03", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-00-04", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-00-05", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-00-06", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-00-07", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-00-08", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-00-09", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-00-10", Constants.SPRITESHEET_GAME),
        ];
        this.addChild(
            ...this._flags,
            ...this._objects,
        );
        CustomBounce.create("customBounce-mexico", { strength: 0.3, squash: 0 });
    }

    /** @override */
    public AnimateIn(pCallback: () => void, pDelay: number = 0): void {
        if (this._introTimeline !== undefined) {
            this._introTimeline.kill();
        }
        // this._introTimeline.clear();
        this._introTimeline = new TimelineMax();

        this._introTimeline
            .fromTo(this._flags, 2,
                {pixi: { positionY: -this._size!.y / 2 }},
                {pixi: { positionY: 0 }, ease: Linear.easeIn },
                pDelay + 0.75,
            )
            .staggerFromTo(this._objects, 1,
                {pixi: {positionY: -this._size!.y}},
                {pixi: {positionY: 0}, ease: "customBounce-mexico"},
                0.2,
                pDelay,
                pCallback,
            )
            .call(() => this._introTimeline = undefined)
        ;

        for (let i = 0; i < this._objects.length; i++) {
            const t = pDelay + 0.5 + (0.2 * i);
            this._introTimeline.call(() => {
                Application.instance.audio.play(HLF.ArrayUtils.random(SFX.IMPACTS), 0.5, false, HLF.AudioCategory.SFX);
            }, undefined, undefined, t);
        }
    }
    /** @override */
    public AnimateOut() {
        if (this._outroTimeline !== undefined) {
            this._outroTimeline.kill();
        }
        this._outroTimeline = new TimelineMax();
        // this._outroTimeline.clear();
        this._outroTimeline
            .to(this._objects, 0.5, {pixi: {positionY: this._size!.y, ease: Expo.easeOut}}, 0)
            .to(this._flags, 1, {pixi: {positionY: -this._size!.y / 2}}, 1)
            .call(() => this._outroTimeline = undefined)

        ;
    }
}
